var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.213 17.46L12 13.674l3.787 3.787c.219.22.574.22.794 0l.88-.88c.219-.219.219-.574 0-.793L13.673 12l3.787-3.787c.22-.22.22-.574 0-.794l-.88-.88c-.219-.219-.574-.219-.794 0L12 10.327 8.213 6.54c-.22-.22-.575-.22-.794 0l-.88.88c-.219.218-.219.574 0 .793L10.326 12 6.54 15.787c-.219.22-.219.574 0 .794l.88.88c.22.219.575.219.794 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconClose);
export default __webpack_public_path__ + "static/media/elements-icon-close.7bac57f3b1cc82976a5664b8e76b31ce.svg";
export { ForwardRef as ReactComponent };